import React from "react";
import ConfigurationMaster from "./ConfigurationMaster";

function AffectedService() {
    return (
        <ConfigurationMaster
            type="affectedservice"
        />
    );
}

export default AffectedService;